export default {
  name: 'DeviceInfoBoxes',
  computed: {
    numberOfConnection () {
      return this.total.connected_devices || this.total.connected_devices === 0 ? this.total.connected_devices : '--'
    },
    numberOfDevices () {
      return this.total.devices || this.total.devices === 0 ? this.total.devices : '--'
    }
  },
  props: {
    total: {
      required: true,
      type: Object
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/DeviceInfoBoxes/DeviceInfoBoxes.js